/* POYOPOP game, "Jazzed" effects: screen shake, dealer pop, sparkles and confetti.
   Listens to the game's own poyo:stage events, so poyo-game.js is untouched. Loaded only when Style = Jazzed. */
(function () {
  var root = document.getElementById('PoyoGame');
  if (!root || !root.classList.contains('pg--jazz')) return;
  var reduced = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var fun = root.getAttribute('data-confetti') !== 'false' && !reduced;
  var card = root.querySelector('.pg-card');
  var accent = getComputedStyle(root).getPropertyValue('--pgj-accent').trim() || '#111';

  function kick(el, cls) { if (!el || reduced) return; el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); setTimeout(function () { el.classList.remove(cls); }, 700); }

  function sparkle(target, n) {
    if (!fun || !target) return;
    var host = root.querySelector('.ds-half--bottom') || card;
    var hr = host.getBoundingClientRect(), r = target.getBoundingClientRect();
    var s = document.createElement('span'); s.className = 'pgj-spark';
    s.style.left = (r.left - hr.left + r.width / 2) + 'px'; s.style.top = (r.top - hr.top + r.height / 2) + 'px';
    for (var i = 0; i < (n || 8); i++) {
      var a = (Math.PI * 2 * i) / (n || 8) + Math.random() * .5, d = 22 + Math.random() * 22, b = document.createElement('i');
      b.style.setProperty('--x', Math.cos(a) * d + 'px'); b.style.setProperty('--y', Math.sin(a) * d + 'px'); s.appendChild(b);
    }
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    host.appendChild(s); setTimeout(function () { s.remove(); }, 900);
  }

  function confetti(big) {
    if (!fun) return;
    var box = document.createElement('div'); box.className = 'pgj-confetti'; box.setAttribute('aria-hidden', 'true');
    var colors = [accent, '#111', '#fff', accent, '#111'], n = big ? 70 : 36;
    for (var i = 0; i < n; i++) {
      var c = document.createElement('i'), k = Math.random();
      if (k > .82) c.className = 'is-poyo'; else if (k > .6) c.className = 'is-star';
      c.style.left = (Math.random() * 100) + 'vw';
      c.style.setProperty('--c', colors[i % colors.length]);
      c.style.setProperty('--x', (Math.random() * 160 - 80) + 'px');
      c.style.setProperty('--r', (Math.random() * 900 - 450) + 'deg');
      c.style.setProperty('--t', (1.6 + Math.random() * 1.6) + 's');
      c.style.setProperty('--d', (Math.random() * .5) + 's');
      box.appendChild(c);
    }
    document.body.appendChild(box); setTimeout(function () { box.remove(); }, 4000);
  }

  var slot = root.querySelector('.pg-slot');
  window.addEventListener('poyo:stage', function (e) {
    var d = e.detail || {}, st = d.stage;
    if (st === 'match-pair') {
      var up = root.querySelectorAll('.pgm-card.is-matched');
      sparkle(up[up.length - 1]); sparkle(up[up.length - 2], 6); kick(slot, 'pgj-pop');
    } else if (st === 'match-miss' || st === 'poker-lose') {
      kick(card, 'pgj-shake'); kick(slot, 'pgj-pop');
    } else if (st === 'match-win' || st === 'poker-win') {
      kick(card, 'pgj-bump'); kick(slot, 'pgj-pop'); confetti(false);
    } else if (st === 'poker-draw') {
      kick(slot, 'pgj-pop');
    } else if (st === 'poker-select') {
      var sel = root.querySelectorAll('.pk-row--you .pk-card')[d.card]; if (d.selected) sparkle(sel, 5);
    } else if (st === 'high-score' || st === 'revealed') {
      confetti(true);
    }
  });
})();
